import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './event.types';
import * as constants from './event.constants';

export const eventReducer = generateResourceReducer<types.IEvent>({
  STORE: constants.STORE_EVENT,
  CLEAR: constants.CLEAR_EVENT,
});
